import React, { useState, useEffect } from "react";
import OtpChannelModal from "./OtpChannelModal";

let opener = null;

export const askOtpChannel = () =>
  new Promise((resolve) => {
    if (!opener) return resolve(undefined);
    opener(resolve);
  });

export default function OtpChannelHost() {
  const [resolver, setResolver] = useState(null);

  useEffect(() => {
    opener = (r) => setResolver(() => r);
    return () => { opener = null; };
  }, []);

  const close = (val) => {
    if (resolver) resolver(val);
    setResolver(null);
  };

  return (
    <OtpChannelModal
      open={!!resolver}
      onClose={() => close(null)}
      onSelect={(c) => close(c)}
    />
  );
}